import { getImageUrl } from '../../../shared/image-utils';
import {  Image } from 'antd';

export function ImagePreview({ imagePath }: { imagePath: string; }) {
  const url = getImageUrl(imagePath);
  const thumbUrl = getImageUrl(imagePath, { variant: '200x200' });

  return <Image
    width={200}
    height={200}
    src={thumbUrl}
    preview={{
      src: url,
    }}
    style={{ objectFit: 'cover', objectPosition: 'center' }}
  />
}
